<template>
  <div
    class="offcanvas offcanvas-end show"
    style="
      visibility: visible;
      min-width: 60vw;
      box-shadow: 0 1px 2px rgb(56 65 74 / 15%);
      z-index: 2100;
    "
  >
    <div class="offcanvas-header bg-light p-3">
      <h5 class="modal-title">{{this.$t('page.event-management.EventRecording')}}</h5>
      <button type="button" class="btn-close" @click="handleClose"></button>
    </div>
    <div class="offcanvas-body">
      <div>
        <div class="row mb-3">
          <div class="col">
            <div class="mb-2 text-body fs-16">{{this.$t('page.event-management.EventNumber')}}</div>
            <div>{{ showData.readableNo }}</div>
          </div>
          <div class="col">
            <div class="mb-1">{{this.$t('base.type')}}</div>
            <div>
              <img
                src="@/assets/images/eventtype-warning.svg"
                style="width: auto; height: auto;"
                v-if="
                  showData.level === 'WARNING' &&
                  showData.kind != 'TIME_BASED_DYTHRESHOLD_PREDICATE'
                "
              />
              <img
                src="@/assets/images/eventtype-error.svg"
                style="width: auto; height: auto;"
                v-if="showData.level === 'ERROR'"
              />
              <img
                src="@/assets/images/eventtype-alarm.svg"
                style="width: auto; height: auto;"
                v-if="
                  showData.level === 'WARNING' &&
                  showData.kind == 'TIME_BASED_DYTHRESHOLD_PREDICATE'
                "
              />
              <img
                src="@/assets/images/eventtype-remind.svg"
                style="width: auto; height: auto;"
                v-if="showData.level === 'NORMAL'"
              />
              <img
                src="@/assets/images/eventtype-unknown.svg"
                style="width: auto; height: auto;"
                v-if="showData.level === 'UNKNOWN'"
              />

              <span
                v-if="
                  showData.level != 'WARNING' &&
                  showData.kind != 'TIME_BASED_DYTHRESHOLD_PREDICATE'
                "
                class="ms-1"
              >
                {{ filterEventType(showData.level) || showData.name  }}
              </span>
              <span
                v-if="
                  showData.level === 'WARNING' &&
                  showData.kind === 'TIME_BASED_DYTHRESHOLD_PREDICATE'
                "
                class="ms-1"
              >
                {{this.$t('page.event-management.IntelligentAlarm')}}
              </span>
              <span
                v-if="
                  showData.level === 'WARNING' &&
                  showData.kind != 'TIME_BASED_DYTHRESHOLD_PREDICATE'
                "
                class="ms-1"
              >
                {{this.$t('page.event-management.warning')}}
              </span>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col">
            <div class="mb-2 text-body fs-16">{{this.$t('page.event-management.AffectedEquipment')}}</div>
            <div>
              <span class="me-2">{{ showData.device_name || "-" }}</span>
              <router-link
                :to="{
                  path: '/equipment-detail',
                  query: { equip_id: showData.deviceId },
                }"
                class="fw-medium link-primary"
                >{{this.$t('page.equipment-info')}}</router-link
              >
            </div>
          </div>
          <div class="col">
            <div class="mb-2 text-body fs-16">{{this.$t('page.event-management.AffectedSensor')}}</div>
            <div>
              <span class="me-2">{{ showData.measure_name }}</span>
              <span
                @click="goHistory()"
                class="link-primary"
                style="cursor: default"
                >{{this.$t('page.health-monitoring.viewing_historical_data')}}</span
              >
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col">
            <div class="mb-2 text-body fs-16">{{this.$t('page.event-management.OccurrenceTime')}}</div>
            <div>
              {{
                (showData.createdAt &&
                  moment(showData.createdAt)
                    .tz($tz)
                    .format("YYYY-MM-DD HH:mm:ss")) ||
                "-"
              }}
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col">
            <div class="mb-2 text-body fs-16">
              {{
                showData.kind == "TIME_BASED_DYTHRESHOLD_PREDICATE"
                  ? this.$t('page.event-management.PredictiveMaintenanceModule')
                  : this.$t('page.event-management.BriefDescription')
              }}
            </div>
            <div
              v-if="showData.kind == 'TIME_BASED_DYTHRESHOLD_PREDICATE'"
              class="text-wrap text-break"
            >
              {{
                showData.device_name +
                " " +
                showData.measure_name
              }}{{this.$t('page.event-management.AbnormalPerformancePleasePayAttention')}}
            </div>
            <div v-else class="text-wrap text-break">
              {{
                showData.device_name +
                " " +
                showData.measure_name
              }}
              {{this.$t('page.event-management.enter')}}{{ status[showData.level] }}{{this.$t('page.service-request.status.text')}}
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col">
            <div class="mb-2 text-body fs-16">{{this.$t('page.event-management.EventMap')}}</div>
            <div class="bg-light p-2" style="width: 100%">
              <div class="bg-white">
                <div id="eventchart" style="height: 300px"></div>
                <div
                  class="pt-2 pb-2 d-flex justify-content-center align-items-center w-100 flex-column"
                >
                  <div class="fs-16 mb-1">{{ showData.measure_name }}</div>
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="goHistory()"
                    style=""
                  >
                    <i
                      class="mdi fs-16 mdi-chart-areaspline text-white me-1"
                    ></i
                    >{{this.$t('page.health-monitoring.viewing_historical_data')}}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col">
            <div class="mb-2 text-body fs-16">{{this.$t('page.event-management.FaultCauseAnalysisSuggestions')}}</div>
            <div class="text-muted text-wrap text-break">
              {{ showData.suggestion || "-" }}
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col">
            <div class="mb-2 text-body fs-16">{{this.$t('page.event-management.RelatedProcessDescription')}}</div>
            <div class="text-muted text-wrap text-break">
              {{ showData.instruction || "-" }}
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col">
            <div class="mb-2 text-body fs-16">
              <span>{{this.$t('page.event-management.RelativeResults')}}</span>
              <span
                class="fw-medium link-primary fs-13"
                @click="eventsGather"
                style="cursor: default"
                >{{this.$t('page.event-management.EventBase')}}</span
              >
            </div>
            <div>
              <div>
                <table class="table align-middle table-bordered">
                  <thead class="table-light">
                    <tr>
                      <th scope="col">{{this.$t('page.event-management.EventNumber')}}</th>
                      <th scope="col">{{this.$t('page.event-management.OccurrenceTime')}}</th>
                      <th scope="col">{{this.$t('page.event-management.BriefDescription')}}</th>
                      <th scope="col" style="width: 80px">{{this.$t('page.service-request.status.text')}}</th>
                      <th scope="col">{{this.$t('page.event-management.UpdateTime')}}</th>
                    </tr>
                  </thead>
                  <tbody class="list">
                    <tr
                      v-for="(item, index) in relateEventsList"
                      :key="index"
                      v-show="relateEventsList.length"
                    >
                      <td>
                        <span
                          class="link-primary"
                          style="cursor: pointer"
                          @click="viewDetail(item.id)"
                          >{{ item.readableNo }}</span
                        >
                      </td>
                      <td>
                        {{
                          (item.createdAt &&
                            moment(item.createdAt)
                              .tz($tz)
                              .format("YYYY-MM-DD HH:mm:ss")) ||
                          "-"
                        }}
                      </td>
                      <td>
                        {{
                          showData.device_name +
                          " " +
                          showData.measure_name
                        }}
                        {{this.$t('page.event-management.enter')}}{{ status[item.level] }}{{this.$t('page.service-request.status.text')}}
                      </td>
                      <td>
                        <div class="btn-group">
                          <span
                            :class="[
                              'badge',
                              item.status === 'PENDING' && 'badge-open',
                              item.status === 'PROCESSING' && 'badge-handling',
                              item.status === 'WAITING_CONFIRM' &&
                                'badge-waitconfirm',
                              item.status === 'CLOSED' && 'badge-closed',
                              item.status === 'SCHEDULED' && 'badge-released',
                              item.status === 'SOLVED' && 'badge-solved',
                            ]"
                            >{{ filterEventState(item.status) }}</span
                          >
                        </div>
                      </td>
                      <td>
                        {{
                          (item.updatedAt &&
                            moment(item.updatedAt)
                              .tz($tz)
                              .format("YYYY-MM-DD HH:mm:ss")) ||
                          "-"
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col">
            <div class="text-body fs-16">{{this.$t('page.event-management.EventReport')}}</div>
            <div class="mb-2 text-muted fs-12">
              {{this.$t('page.event-management.DescribeEventImpactProblem')}}
            </div>
            <div>
              <textarea
                class="form-control"
                rows="3"
                v-model="report.description"
              ></textarea>
              <b-accordion
                class="lefticon-accordion custom-accordionwithicon accordion-border-box"
                id="accordionlefticon"
              >
                <b-accordion-item :title="this.$t('page.event-management.HistoricalReport')" visible>
                  <SimpleBar
                    class="upcoming-events pe-2 me-n1 mb-3"
                    data-simplebar="init"
                    v-if="reportList.length"
                  >
                    <div v-for="(rep, i) in reportList" :key="i" class="mb-3">
                      <div>
                        <span class="fs-14 text-body me-5">{{
                          rep.userName
                        }}</span>
                        <span class="fs-12 text-muted">{{
                          rep.createTime &&
                          moment(rep.createTime)
                            .tz($tz)
                            .format("YYYY-MM-DD HH:mm:ss")
                        }}</span>
                      </div>
                      <div class="fs-14 text-muted">{{ rep.description }}</div>
                    </div>
                  </SimpleBar>
                  <div v-show="!reportList.length" class="text-center">
                    {{this.$t('page.event-management.NoHistoricalReport')}}
                  </div>
                </b-accordion-item>
              </b-accordion>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col">
            <div class="text-body fs-16 mb-2">{{this.$t('base.picture')}}</div>
            <DropZone
              @drop.prevent="drop($event, 0)"
              @change="selectedFile(0)"
              :fileInfo="{
                title: this.$t('page.event-management.click_upload_pictures'),
                accept: 'PNG、JPEG、JPG',
                limit: '50M',
              }"
              :accept="'.png,.jpeg,.jpg'"
            />
            <div>
              <div class="text-body fs-14 mt-2 mb-2">{{this.$t('page.event-management.UploadedPicture')}}</div>
              <div class="border border-solid rounded" v-if="imagesList.length">
                <div
                  class="product-img-slider sticky-side-div ps-5 pe-5 ps-5 pe-5 pt-3 pb-3"
                >
                  <SwiperTool
                    :swiperInfo="{
                      type: 'image',
                      page: 'eventmanagedetail',
                      spaceBetween: 10,
                      slidesPerView: 6,
                      actionsClass: [
                        { name: 'ri-eye-fill', action: 'view' },
                        { name: 'ri-download-2-fill', action: 'download' },
                        { name: 'ri-delete-bin-5-fill', action: 'delete' },
                      ],
                    }"
                    :list="imagesList"
                    @deleteFile="deleteFile"
                  >
                  </SwiperTool>
                </div>
              </div>
              <div v-show="!imagesList.length" class="text-center">
                {{this.$t('page.event-management.NoUploadedPicture')}}
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col">
            <div class="text-body fs-16 mb-2">{{this.$t('base.document')}}</div>
            <DropZone
              @drop.prevent="drop($event, 1)"
              @change="selectedFile(1)"
              :fileInfo="{
                title: this.$t('page.event-management.ClickUploadDocument'),
                accept: 'PPT、PDF、EXCEL、WORD',
                limit: '50M',
              }"
              :ID="'dropzoneFile1'"
              :accept="'.ppt,.pptx,.pdf,.xls,.xlsx,.doc,.docx'"
            />
            <div>
              <div class="text-body fs-14 mt-2 mb-2">{{this.$t('page.event-management.UploadedDocument')}}</div>
              <div
                class="border border-solid rounded"
                v-if="documentList.length"
              >
                <div
                  class="product-img-slider sticky-side-div ps-5 pe-5 pt-3 pb-3"
                >
                  <SwiperTool
                    :swiperInfo="{
                      type: 'document',
                      page: 'eventmanagedetail',
                      spaceBetween: 10,
                      slidesPerView: 6,
                      actionsClass: [
                        { name: 'ri-eye-fill', action: 'view' },
                        { name: 'ri-download-2-fill', action: 'download' },
                        { name: 'ri-delete-bin-5-fill', action: 'delete' },
                      ],
                    }"
                    :list="documentList"
                    @deleteFile="deleteFile"
                  >
                  </SwiperTool>
                </div>
              </div>
              <div v-show="!documentList.length" class="text-center">
                {{this.$t('page.event-management.NoUploadedDocument')}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="offcanvas-footer border-top p-3 text-center">
      <div class="hstack gap-2 justify-content-end">
        <button type="button" class="btn btn-light" @click="handleClose">
          {{this.$t('base.cancel')}}
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="handleSave(showData)"
        >
          {{this.$t('base.save')}}
        </button>
      </div>
    </div>
  </div>
  <!-- <div class="offcanvas-backdrop fade show"></div> -->
</template>
<script>
import { SimpleBar } from "simplebar-vue3";
import SwiperTool from "@/components/swiperTool.vue";
import DropZone from "@/components/widgets/dropZone";
import { eventTypeList, eventStateList } from "@/utils/selectText.js";
import { spectrumEcharts2 } from "@/utils/chart";
import moment from "moment";
import {
  getEventsList,
  putEventBasicInfo,
  putEventAttach,
  getUploadFileDetail,
  getUploadFileSign,
  getRawTimeseries,
  getInstancesDetailId,
} from "@/service/index.js";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import _ from "loadsh";
import qs from "qs";
import "moment-timezone";
import { imageCompress, valueFormatter } from "@/utils/common.js";
/* import { ElMessage } from 'element-plus'
import 'element-plus/theme-chalk/el-message.css'
import 'element-plus/es/components/message/style/css' */

export default {
  emits: [
    "update:isShowDetail",
    "handleAlert",
    "getEventsDetailInfo",
    "setEventsList",
    "freshKey",
    "freshPage",
  ],
  props: {
    isShowDetail: Boolean,
    singleData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    sysList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  components: {
    SimpleBar,
    DropZone,
    SwiperTool,
  },
  setup() {
    return {};
  },
  data() {
    return {
      relateEventsList: [],
      reportList: [],
      imagesList: [],
      documentList: [],
      report: {
        description: "",
        userName: localStorage.getItem("username") || "",
        createTime: moment().format("YYYY-MM-DD HH:mm:ss"),
      },
      showData: {},
      fileMaxSize: 1024 * 1024 * 50,
      windowTimeseriesData: [],
      status: {
        WARNING: this.$t('page.event-management.sub-health'),
        ERROR: this.$t('page.event-management.abnormal'),
        FATAL: this.$t('page.event-management.IntelligentAlarm'),
        NORMAL: this.$t('page.event-management.health'),
        UNKNOWN: this.$t('page.event-management.unknown'),
      },
      chartParams: {}, //点击查看历史图谱需传递的参数
      startTime: null, //点击查看历史图谱需传递的参数
      endTime: null, //点击查看历史图谱需传递的参数
    };
  },
  watch: {
    isShowDetail:{
        handler(){
            if(this.showData.deviceId)
            this.getValueChartsData(this.showData);

        }, deep: true,
      immediate: true,
    },
    singleData: {
      handler(newVal) {
        this.showData = newVal;
        this.reportList = [];
        this.imagesList = [];
        this.documentList = [];
        if (this.showData.measure_info)
          if (this.showData.measure_key && this.showData.deviceId) {
            this.getEventsRelatedList();
          }

        if (newVal.deviceId) {
          this.getValueChartsData(newVal);
        }

        if (
          this.showData.attachments &&
          this.showData.attachments.attachments
        ) {
          this.imagesList = this.filterAttachment(
            this.showData.attachments.attachments,
            "image"
          );
          this.documentList = this.filterAttachment(
            this.showData.attachments.attachments,
            "document"
          );
        }

        if (
          this.showData.additionalInfo &&
          this.showData.additionalInfo.report
        ) {
          this.reportList = JSON.parse(this.showData.additionalInfo.report);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    moment,
    viewDetail(id) {
      let deviceInfo = {
        measure_name: this.showData.measure_name,
        measure_key: this.showData.measure_key,
        suggestion: this.showData.suggestion,
        instruction: this.showData.instruction,
        deviceId: this.showData.deviceId,
        device_name: this.showData.device_name,
        设备所在区域: this.showData['设备所在区域'],
        机组名称: this.showData['机组名称'],
        measure_info: this.showData.measure_info,
      };
      this.getValueChartsData(this.showData);

      this.$emit("getEventsDetailInfo", id, deviceInfo);
    },
    filterEventType(val) {
      let info = eventTypeList.find((item) => {
        return item.value === val;
      });
      if (info) {
        return info.label;
      }
    },
    filterEventState(val) {
      let info = eventStateList.find((item) => {
        return item.value === val;
      });
      if (info) {
        return info.label;
      }
    },
    filterAttachment(attachs, type) {
      if (!attachs) return;
      let list = attachs.filter((item) => {
        let suffix = item.originName.substring(
          item.originName.lastIndexOf(".")
        );
        if (type === "image") {
          return /\.(png|jpeg|jpg)$/.test(suffix);
        } else if (type === "document") {
          return /\.(ppt|pptx|pdf|xls|xlsx|doc|docx)$/.test(suffix);
        }
      });
      return list;
    },
    checkFile(file) {
      let name = /^events\//.test(file.name)
        ? file.name.substring(44)
        : file.name;
      let suffix = name.substring(name.lastIndexOf("."));
      let type = /\.(png|jpeg|jpg)$/.test(suffix)
        ? "imagesList"
        : "documentList";
      let i = this[type].findIndex((item) => {
        let originName = /^events\//.test(item.originName)
          ? item.originName.substring(44)
          : item.originName;
        return originName === name;
      });
      return i == -1;
    },
    async selectedFile(n) {
      let dropzoneFile =
        n == 1
          ? document.querySelector("#dropzoneFile1").files[0]
          : document.querySelector(".dropzoneFile").files[0];

      if (!dropzoneFile) return;

      if (dropzoneFile.size > this.fileMaxSize) {
        this.$emit("handleAlert", "danger", this.$t('page.files_upload.file_size_cannot_exceed_50M'));
        n == 1
          ? (document.getElementById("dropzoneFile1").value = "")
          : (document.getElementById("dropzoneFile").value = "");
        return;
      }

      if (!this.checkFile(dropzoneFile)) {
        this.$emit(
          "handleAlert",
          "danger",
          this.$t('page.event-management.FileWithTheSameNameAlreadyExists')
        );
        n == 1
          ? (document.getElementById("dropzoneFile1").value = "")
          : (document.getElementById("dropzoneFile").value = "");
        return;
      }
      let suffix = dropzoneFile.name.substring(
        dropzoneFile.name.lastIndexOf(".")
      );
      if (/\.(png|jpeg|jpg)$/.test(suffix)) {
        let file = await imageCompress(dropzoneFile);
        this.uploadFileSign(file, n);
      } else {
        this.uploadFileSign(dropzoneFile, n);
      }
    },
    async drop(e, n) {
      let dropzoneFile = e.dataTransfer.files[n];
      if (!dropzoneFile) return;

      if (dropzoneFile.size > this.fileMaxSize) {
        this.$emit("handleAlert", "danger", this.$t('page.files_upload.file_size_cannot_exceed_50M'));
        n == 1
          ? (document.getElementById("dropzoneFile1").value = "")
          : (document.getElementById("dropzoneFile").value = "");
        return;
      }

      if (!this.checkFile(dropzoneFile)) {
        this.$emit(
          "handleAlert",
          "danger",
          this.$t('page.event-management.FileWithTheSameNameAlreadyExists')
        );
        n == 1
          ? (document.getElementById("dropzoneFile1").value = "")
          : (document.getElementById("dropzoneFile").value = "");
        return;
      }

      let suffix = dropzoneFile.name.substring(
        dropzoneFile.name.lastIndexOf(".")
      );
      if (/\.(png|jpeg|jpg)$/.test(suffix)) {
        let file = await imageCompress(dropzoneFile);
        this.uploadFileSign(file, n);
      } else {
        this.uploadFileSign(dropzoneFile, n);
      }
    },
    uploadFileSign(file, n) {
      Swal.fire({ title: this.$t('page.files_upload.uploading'), showConfirmButton: false });
      Swal.showLoading();
      let filename = file.name;
      let objectName = `events/${uuidv4()}/${filename}`;
      let params = {
        object: objectName,
        method: "upload",
      };
      getUploadFileSign(params)
        .then((res) => {
          let suf = filename.substring(filename.lastIndexOf("."));
          if (res && res.payload) {
            axios
              .put(res.payload.signedUrl, file, {
                headers: { "Content-Type": file.type },
              })
              .then(() => {
                let params = {
                  object: objectName,
                };
                getUploadFileDetail(params).then((resDetail) => {
                  if (resDetail && resDetail.payload) {
                    let detail = resDetail.payload;
                    let info = {
                      url: detail.url,
                      etag: detail.etag,
                      size: detail.size,
                      // content_type: detail.contentType,
                      originName: detail.objectName,
                      // last_modified: detail.lastModified,
                      ext: suf.substring(1),
                      mime: detail.contentType,// file.type,
                      alt: this.$t('page.event-management.EventPicture'),
                    };
                    let suffix = info.originName.substring(
                      info.originName.lastIndexOf(".")
                    );
                    if (/\.(png|jpeg|jpg)$/.test(suffix)) {
                      this["imagesList"].push(info);
                    } else {
                      this["documentList"].push(info);
                    }
                    n == 1
                      ? (document.getElementById("dropzoneFile1").value = "")
                      : (document.getElementById("dropzoneFile").value = "");
                    Swal.close();
                    this.$emit(
                      "handleAlert",
                      "success",
                      this.$t('base.upload_success'),
                      "ri-check-double-line"
                    );
                  }
                });
              })
              .catch(() => {
                n == 1
                  ? (document.getElementById("dropzoneFile1").value = "")
                  : (document.getElementById("dropzoneFile").value = "");
                Swal.close();
                this.$emit(
                  "handleAlert",
                  "danger",
                  this.$t('base.delete_failed_please_try_again'),
                  "ri-error-warning-line"
                );
              });
          }
        })
        .catch(() => {
          n == 1
            ? (document.getElementById("dropzoneFile1").value = "")
            : (document.getElementById("dropzoneFile").value = "");
          Swal.close();
          this.$emit(
            "handleAlert",
            "danger",
            this.$t('base.delete_failed_please_try_again'),
            "ri-error-warning-line"
          );
        });
    },
    getValueChartsData(info) {
      const diffmin = moment(new Date()).diff(moment(info.createdAt), "minute"); //计算相差的分钟数
      this.endTime = null;
      this.startTime = null;
      if (diffmin > 30) {
        this.startTime = moment(info.createdAt)
          .subtract(30, "minute")
          .valueOf();
        this.endTime = moment(info.createdAt).add(30, "minute").valueOf();
      } else {
        this.startTime = moment(info.createdAt)
          .subtract(60, "minute")
          .valueOf();
        this.endTime = moment(info.createdAt).valueOf();
      }

      this.chartParams = {
        end: moment().utc().diff(moment(this.endTime), "minute") + "m",
        start: moment().utc().diff(moment(this.startTime), "minute") + "m",
      }; //跳转到图谱的参数

      let rawChartParams = {
        start: moment().utc().diff(moment(this.startTime), "minute") + "m",
        end: moment().utc().diff(moment(this.endTime), "minute") + "m",
        limit: 7200,
        column: [
          info.measure_key,
          info.measure_key + "_dythreshold" + "_upper",
          info.measure_key + "_dythreshold" + "_lower",
        ],
      };

      const p1 = new Promise((resolve) => {
        getRawTimeseries(
          info.deviceId,
          qs.stringify(rawChartParams, { arrayFormat: "repeat" })
        ).then((res) => {
          return resolve(res.payload);
        });
      });
      Promise.all([p1]).then((result) => {
        var list = [
          {
            name: info.measure_name,
            key: info.measure_key,
            unit: info.measure_info.unit,
            type: "line",
            symbolSize: 0,
            data: [],
            lineStyle: {
              normal: {
                width: 1,
              },
              emphasis: { width: 2 },
            },
          },
        ];
        this.windowTimeseriesData = [...result[0]];
        var upperData = {
          key: info.measure_key + "_dythreshold_upper",
          name: this.$t('page.event-management.DynamicThresholdHigh'),
          type: "line",
          smooth: true,
          showSymbol: false,

          lineStyle: {
            width: 0,
          }, // 隐藏线
          areaStyle: {
            color: "rgba(80, 195, 230, 0.4)",
          }, // 上限区域
          data: [],
        };
        var lowerData = {
          key: info.measure_key + "_dythreshold_lower",
          name: this.$t('page.event-management.DynamicThresholdLow'),

          type: "line",
          smooth: true,
          showSymbol: false,
          lineStyle: {
            width: 0,
          }, //隐藏线
          areaStyle: {
            color: "rgba(80, 195, 230, 0.4)",
          }, // 下限区域
          data: [],
        };

        this.windowTimeseriesData.map((item, index) => {
          list.map((s) => {
            for (let i in item) {
              if (s.key == i) {
                if (
                  index == 0 &&
                  moment(item["ts"]).valueOf() > this.startTime
                ) {
                  s.data.unshift([this.startTime, ""]);
                }
                s.data.push([
                  moment(item["ts"]).tz(this.$tz).valueOf(),
                  valueFormatter(item[i]),
                ]);
                if (
                  index == this.windowTimeseriesData.length - 1 &&
                  moment(item["ts"]).valueOf() < this.endTime
                ) {
                  s.data.push([this.endTime, ""]);
                }
              }
            }
          });
          if (item[upperData.key] && item[lowerData.key]) {
            upperData.data.push({
              name: moment(item["ts"])
                .format("YYYY-MM-DD HH:mm:ss.SSS")
                .valueOf(),
              value: [
                moment(item["ts"]).format("YYYY-MM-DD HH:mm:ss.SSS").valueOf(),
                item[upperData.key] && item[upperData.key].toFixed(2),
              ],
            });
            lowerData.data.push({
              name: moment(item["ts"])
                .format("YYYY-MM-DD HH:mm:ss.SSS")
                .valueOf(),
              value: [
                moment(item["ts"]).format("YYYY-MM-DD HH:mm:ss.SSS").valueOf(),
                item[lowerData.key] && item[lowerData.key].toFixed(2),
              ],
            });
          }
        });
        this.$nextTick(() => {
          spectrumEcharts2({
            chartDom: document.getElementById("eventchart"),
            dataList: [...list, upperData, lowerData],
            unit: _.get(this.showData, ["measure_info", "unit"]) || "",
          });
        });
      });

      // .catch((err) => {ElMessage.error(err || "获取事件图谱数据失败,请重试！")});
    },
    getEventsRelatedList() {
      let data = {
        telemetry: this.showData.measure_key,
        page: 0,
        limit: 5,
        shadowId: this.showData.deviceId,
      };
      let params = qs.stringify(data, { arrayFormat: "repeat" });
      getEventsList(params).then((res) => {
        if (res.payload && res.payload.data) {
          this.relateEventsList = res.payload.data;
        }
      });
      /* .catch(()=>{
        ElMessage.error("获取事件相关列表失败,请重试！")
        this.$emit("handleAlert","danger","获取事件相关列表失败,请重试！")
      }) */
    },
    handleClose() {
      this.$emit("update:isShowDetail", false);
    },
    handleSave(event) {
      Swal.fire({ title: this.$t('base.saving'), showConfirmButton: false });
      Swal.showLoading();
      if (this.report.description) {
        this.reportList.push(this.report);
      }
      let infoparams = {
        status: event.status,
        additionalInfo: {
          report: JSON.stringify(this.reportList),
        },
      };
      let attachParams = {
        attachments: [...this.imagesList, ...this.documentList],
      };
      let p1 = new Promise((resolve, reject) => {
        putEventBasicInfo(event.id, infoparams)
          .then((res) => {
            return resolve(res);
          })
          .catch(() => {
            return reject(this.$t('page.event-management.EventReport'));
          });
      });

      let p2 = new Promise((resolve, reject) => {
        putEventAttach(event.id, attachParams)
          .then((res) => {
            return resolve(res);
          })
          .catch(() => {
            return reject(this.$t('base.FilePictureData'));
          });
      });

      Promise.allSettled([p1, p2]).then((result) => {
        Swal.close();
        if (result.length) {
          let failList = result.filter((item) => {
            return item.status === "rejected";
          });
          if (failList.length) {
            let failRea = _.map(failList, "reason");
            this.$emit("handleAlert", "danger", `保存${failRea}失败！`);
          } else {
            this.$emit("freshPage");
            this.$emit(
              "handleAlert",
              "success",
              this.$t('base.save_success'),
              "ri-check-double-line"
            );
          }
          this.handleClose();
        }
      });
    },
    deleteFile(i, type) {
      if (type == "image") {
        this.imagesList.splice(i, 1);
      } else if (type == "document") {
        this.documentList.splice(i, 1);
      }
    },
    goHistory() {
      var obj = this.sysList.filter((o) => {
        return (
          o.id == this.showData.deviceId && o.name == this.showData.device_name
        );
      });
      sessionStorage.setItem("deviceTreeActive", obj[0].id);
      localStorage.setItem("equipmentData", JSON.stringify(...obj));
      //   localStorage.setItem("historyData", JSON.stringify([item]));
      //   sessionStorage.setItem("deviceTreeActive", obj[0].id);
      localStorage.setItem(
        "historyData",
        JSON.stringify([this.showData.measure_info])
      );
      this.$router.push({
        path: "/iot/atlas-analysis",
        query: {
          ...this.chartParams,
          endTime: this.endTime,
          startTime: this.startTime,
        },
      });
    },
    eventsGather() {
      sessionStorage.setItem("deviceTreeActive", this.showData.deviceId);
      sessionStorage.removeItem("measureInfo");
      getInstancesDetailId({ id: this.showData.deviceId }).then((res) => {
        if (res.payload) {
          this.$emit("freshKey");
          this.$emit(
            "setEventsList",
            res.payload,
            this.showData.deviceId,
            "device"
          );
          this.$emit("update:isShowDetail", false);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.eventempty {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -40%);
}
</style>
